module.exports = __webpack_public_path__ + "img/solucao_aliare.bcaf65f6.svg";